import laptop from '../../assets/Images/laptop.png';
import phones from '../../assets/Images/phones.png';
import watches from '../../assets/Images/watches.png';

export const prizeData=[
    {
        id:"1",
        priceNumber:"1st",
        name:'Laptop',
        imageurl:laptop
    },
     {
        id:"2",
        priceNumber:"2nd",
        name:'3 Smart phones',
        imageurl:phones
    },
      {
        id:"3",
        priceNumber:"3rd",
        name:'5 Smart watches',
        imageurl:watches
    }
]